import React, { useCallback, useState } from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import Skeleton from "@material-ui/lab/Skeleton";

// const data = [
//   { name: "Completed", value: 400 },
//   { name: "Incomplete", value: 300 },
// ];

const COLORS = { completed: "#00C49F", incomplete: "#eeeeee" };

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index,
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.3;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};
export default function ChartPieRoadmap({ data }) {
  return (
    <ResponsiveContainer width="100%" height={60}>
      {data.length > 0 ? (
        <PieChart>
          <Pie
            data={data}
            cx={25}
            cy={25}
            labelLine={false}
            // label
            innerRadius={20}
            outerRadius={30}
            fill="#8884d8"
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                // fill={COLORS[index % COLORS.length]}
                fill={COLORS[entry["name"]]}
              />
            ))}
          </Pie>
          <Tooltip />
        </PieChart>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingRight: "30px",
          }}
        >
          <Skeleton variant="rect" width="80%" height={60} />
        </div>
      )}
    </ResponsiveContainer>
  );
}
